import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { async } from 'rxjs/internal/scheduler/async';
import { AngularFirestore, AngularFirestoreCollection, AngularFirestoreDocument } from 'angularfire2/firestore';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/map'
import {MediaMatcher} from '@angular/cdk/layout';

export interface Parent {
  course_title: string;
  trainer_title: string;
  id?: string;
}

export interface Service{
  service_title:string;
  service_image:string;
  service_description:string;
  service_overview:string;  
  service_dropdown:string;
  service_seoTitle:string;
  service_seoDes:string;
  service_iconUrl:string;
  id?: string;
}

@Component({
  selector: 'app-products',
  templateUrl: './products.component.html',
  styleUrls: ['./products.component.css']
})
export class ProductsComponent implements OnInit {

  mobileQuery: MediaQueryList;
  id: any;
  servicedate: Observable<Service[]>;
  sidebarData:Observable<Service[]>;
  categoryDetails: any;
  panelOpenState = false;
  
  private _mobileQueryListener: () => void;

  constructor(private afs: AngularFirestore, private router: Router, private route: ActivatedRoute, changeDetectorRef: ChangeDetectorRef, media: MediaMatcher) {
    this.mobileQuery = media.matchMedia('(max-width: 600px)');
    this._mobileQueryListener = () => changeDetectorRef.detectChanges();
    this.mobileQuery.addListener(this._mobileQueryListener);

    this.route.params.subscribe(params => {
      this.id = params['id'];
      console.log(this.id)

      if (this.id) {
        this.categoryDetails = [];    
        this.getSingleService(this.id).then(data => {
          data.subscribe(singleservice => {
            console.log(singleservice);
            this.categoryDetails = singleservice;
            this.ngOnInit();
          });
        });
      }
    });
  }

  ngOnInit() {
    const service: AngularFirestoreCollection<Service> = this.afs.collection<Service>('Service', res => {
      return res.where("service_dropdown", "==", this.id).orderBy('createdAt', 'desc');
    });
    this.servicedate = service.snapshotChanges()
      .map(actions => {
        return actions.map(a => {
          const data = a.payload.doc.data() as Service;
          data.id = a.payload.doc.id;
          console.log(data)
          return data
        });
      });

      const sidebar: AngularFirestoreCollection<Service> = this.afs.collection<Service>('Services', res => {
        return res.where("parent_id", "==", this.id).orderBy('createdAt', 'desc');
      });
      this.sidebarData = sidebar.snapshotChanges()
        .map(actions => {
          return actions.map(a => {
            const data = a.payload.doc.data() as Service;
            data.id = a.payload.doc.id;
            console.log(data)
            return data
          });
        });
  }

  getData(id){
    const service: AngularFirestoreCollection<Service> = this.afs.collection<Service>('Service', res => {
      return res.where("service_dropdown", "==", id).orderBy('createdAt', 'desc');
    });
    this.servicedate = service.snapshotChanges()
      .map(actions => {
        return actions.map(a => {
          const data = a.payload.doc.data() as Service;
          data.id = a.payload.doc.id;
          console.log(data)
          return data
        });
      });
  }


  async getSingleService(id) {
    const get = await this.afs.doc(`Parent/${id}`);
    const getdata = await get.valueChanges();
    return getdata;
  }

}
